import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Forwards every "supercast-queue-changed" event to native, so the mini-player's queue button
// can react to a mutation immediately instead of waiting for the next successor prefetch.
export default class extends BridgeComponent {
  static component = "queue-listener";

  connect() {
    super.connect();
    this.handleChange = this.handleChange.bind(this);
    window.addEventListener("supercast-queue-changed", this.handleChange);
  }

  disconnect() {
    super.disconnect();
    window.removeEventListener("supercast-queue-changed", this.handleChange);
  }

  handleChange(event) {
    this.send("changed", { count: event.detail.count });
  }
}
